import React from 'react';
import PropTypes from 'prop-types';
import css from './Table.module.scss';
import {useTableContext} from './TableContext';
import {buildStickyStyle} from './stickyStyle';

const TableCell = ({
  children,
  className = '',
  colSpan,
  rowSpan,
  align,
  style,
  sticky = false,
  stickyOffset,
  stickyTop,
  stickyRight,
  mobileLabel,
}) => {
  const {cellAlign} = useTableContext();
  const finalAlign = align ?? cellAlign ?? 'left';
  const stickyStyle = buildStickyStyle({sticky, stickyOffset, stickyTop, stickyRight});

  return (
    <td
      data-label={mobileLabel || undefined}
      className={`${css.td} ${sticky ? css.sticky : ''} ${className}`.trim()}
      style={{textAlign: finalAlign, ...stickyStyle, ...style}}
      colSpan={colSpan}
      rowSpan={rowSpan}
    >
      {children}
    </td>
  );
};

TableCell.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  colSpan: PropTypes.number,
  align: PropTypes.oneOf(['left', 'center', 'right']),
  style: PropTypes.object,
  sticky: PropTypes.bool,
  stickyOffset: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  stickyTop: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  stickyRight: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  mobileLabel: PropTypes.string,
};

export default TableCell;
